var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobalIcon = function SvgGlobalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2525_5430)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25M20.25 12a8.2 8.2 0 0 1-.6 3.088l-4.19-2.577a1.5 1.5 0 0 0-.586-.21l-2.139-.288a1.51 1.51 0 0 0-1.5.737h-.817l-.357-.737A1.5 1.5 0 0 0 9.03 11.2l-.75-.162.733-1.288h1.567c.253 0 .502-.065.724-.187l1.149-.634q.151-.085.281-.2l2.523-2.283a1.494 1.494 0 0 0 .306-1.843l-.034-.06A8.26 8.26 0 0 1 20.25 12m-16.5 0a8.2 8.2 0 0 1 .8-3.544l1.064 2.838a1.5 1.5 0 0 0 1.09.938l2.008.432.357.742a1.51 1.51 0 0 0 1.35.844h.14l-.679 1.522a1.5 1.5 0 0 0 .268 1.628l.014.013L12 19.307l-.182.937A8.26 8.26 0 0 1 3.75 12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2525_5430"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGlobalIcon;